import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";

// styles
import styles from "./deletableTextbox.module.scss";

type TDeletableTextboxProps = {
    text: string,
    index: number,
    onChange: (index: number, newText: string) => void,
    onDelete: (index: number) => void
}

export const DeletableTextbox: FC<TDeletableTextboxProps> = ({ text, index, onChange, onDelete }: TDeletableTextboxProps) => {

    const onDeleteClick = () => {
        onDelete(index);
    };

    const onTextChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(index, event.target.value);
    };

    return (
        <div className={styles.deletableTextbox}>
            <input className={styles.inputField} type="text" value={text} onChange={onTextChanged} />
            <FontAwesomeIcon icon={faTimes} className={styles.deleteIcon} onClick={onDeleteClick} />
        </div>
    );
};